import { render, staticRenderFns } from "./IntegralRule.vue?vue&type=template&id=a4cfeaca&scoped=true&"
import script from "./IntegralRule.vue?vue&type=script&lang=js&"
export * from "./IntegralRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4cfeaca",
  null
  
)

export default component.exports